/** Shared constants of the TZ records module (class + view files). */

import countries from 'res/js/countries'

export const WIZARD_STEPS = ['tz_files', 'tz_vehicle', 'tz_violation', 'tz_location', 'tz_summary']
export const VIOLATION_TYPES = ['SPD', 'RED', 'STOP']
export const MEASUREMENT_CONTEXTS = ['MUG', 'MUS', 'OMG', 'OMS', 'HWG', 'HWS']
// full country list; the build-time loader already puts PREFERRED_COUNTRIES first
export const LP_COUNTRIES = countries.list.map(c=>c.alpha2)
export const STATE_TONES = { DRAFT: 'warn', READY: 'info', FORWARDED: 'ok', NOTFORWARDED: 'danger', DELETED: 'danger' }
